import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M56.13 12.4199C50.72 5.65992 38.51 1.65991 31.41 1.65991C24.31 1.65991 11.99 5.65992 6.58005 12.4199C-3.10995 24.5299 3.50003 51.1699 3.50003 51.1699C3.50003 51.1699 4.16002 29.59 11.43 23.21C17.62 17.77 23.3 19.86 31.36 19.86C39.42 19.86 45.1 17.78 51.29 23.21C58.56 29.6 59.22 51.1699 59.22 51.1699C59.22 51.1699 65.82 24.5299 56.13 12.4199Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M24.7901 2.22998C24.7901 2.22998 22.3102 7.8399 25.7802 19.8999"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M17.2 4.70996C17.2 4.70996 13.24 10.9899 16.21 20.3999" stroke={outline} strokeMiterlimit="10" />
      <path
        d="M13.7301 6.52991C13.7301 6.52991 8.45011 11.9799 10.5901 23.5399"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M6.24014 12.4199C6.24014 12.4199 0.680157 23.6999 5.63016 35.4299"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M37.9302 2.22998C37.9302 2.22998 40.4102 7.8399 36.9402 19.8999"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M45.5303 4.70996C45.5303 4.70996 49.4903 10.9899 46.5203 20.3999"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M48.9902 6.52991C48.9902 6.52991 54.2702 11.9799 52.1302 23.5399"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M56.4802 12.4199C56.4802 12.4199 62.0403 23.6999 57.0903 35.4299"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
    </g>
  )
}
